import React from 'react';
import { ViolationsSummary } from './ViolationsSummary';
import { InsightSpecialDescriptor, IInsight, InsightDescriptor } from 'utils/entities';
import { NewJobs } from 'components/insight-summary-renderer/NewConstruction';
import { LiensSummary } from './LiensSummary';
import { QuietStreetSummary } from './QuietStreet';
import { BasicRenderer } from './BasicSummary';
import { TabuRegistrationSummary } from './TabuRegistrationSummary';
import { InsightCustomSummary } from 'store/state/selectors/insights/summaryTypes';
import BuildingPermitSummary from './BuildingPermitSummary';

const insightTypeToSummary: Partial<Record<InsightSpecialDescriptor, React.FunctionComponent<{ data: InsightCustomSummary }>>> = {
  [InsightDescriptor.HpdViolations]: ViolationsSummary,
  [InsightDescriptor.NewDevelopmentJobs]: NewJobs,
  [InsightDescriptor.NewDevelopmentJobsArea]: NewJobs,
  [InsightDescriptor.Liens]: LiensSummary,
  [InsightDescriptor.QuietStreet]: QuietStreetSummary,
  [InsightDescriptor.TabuRegistration]: TabuRegistrationSummary,
  [InsightDescriptor.BuildingPermitRequests]: BuildingPermitSummary,
};


interface InsightSummaryRendererProps extends Pick<IInsight, 'summary' | 'type'> {}

export const InsightSummaryRenderer: React.FunctionComponent<InsightSummaryRendererProps> = ({ summary, type }) => {
  if ((type in insightTypeToSummary) && summary.text === null) {
    const SummaryComponent = insightTypeToSummary[type];
    return <SummaryComponent data={summary.nonText ? summary.nonText.data : null} />;
  }
  else {
    return <BasicRenderer content={summary.text} />;
  }
};
